import type from './action-type';

const initialState = {
};


export default (state = initialState, action) => {
	switch (action.type) {
		case type.LOAD_HQ_CHAPTERS:
			return {
				...state,
				...action,
			};
		default:
			return state;
	}
};
